module.exports = __webpack_public_path__ + "images/img-1wNNFjK.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/3.png
// module id = 2339
// module chunks = 0